export const getContractOverview = (dispatch: any, token: string) =>
  dispatch({
    type: "GET_CONTRACTOVERVIEW",
    token,
  });

export const getContractOverviewSuccess = (overview) => ({
  type: "GET_CONTRACTOVERVIEW_SUCCESS",
  overview,
});

export const getContractOverviewFailure = (error: Error) => ({
  type: "GET_CONTRACTOVERVIEW_FAILURE",
  error,
});

export const getContractCode = (dispatch: any, token: string) =>
  dispatch({
    type: "GET_CONTRACTCODE",
    token,
  });

export const getContractCodeSuccess = (code) => ({
  type: "GET_CONTRACTCODE_SUCCESS",
  code,
});

export const getContractCodeFailure = (error: Error) => ({
  type: "GET_CONTRACTCODE_FAILURE",
  error,
});
